
const Loading = () => {
  return (
    <div className="loading-wrapper">
      <div className="loading-circle"></div>
    </div>
  )
}

export default Loading